<template>
  <div class="jxlc-header">
<!--    <div class="header-top w-1180">-->
<!--      <div class="header-left"><a href="http://www.ccb.com" target="_blank">建行官网 www.ccb.com</a></div>-->
<!--      <div class="header-right">-->
<!--        <div class="flex-center">-->
<!--            <el-popover-->
<!--                    placement="bottom"-->
<!--                    width="90"-->
<!--                    trigger="hover">-->
<!--                <img width="90" :src="companyInfo.ccb">-->
<!--                <span slot="reference">-->
<!--                    <el-image :src="appIcon" fit="fill"></el-image><span>建行APP</span>-->
<!--                </span>-->
<!--            </el-popover>-->

<!--        </div>-->
<!--        <div class="header-lines"></div>-->
<!--        <div class="flex-center">-->
<!--            <el-popover-->
<!--                    placement="bottom"-->
<!--                    width="90"-->
<!--                    trigger="hover">-->
<!--                <img width="90" :src="companyInfo.hdn">-->
<!--                <span slot="reference">-->
<!--                    <el-image :src="huiIcon" fit="fill"></el-image>惠懂你-->
<!--                </span>-->
<!--            </el-popover>-->
<!--        </div>-->
<!--        <div class="header-lines"></div>-->
<!--        <div class="flex-center">-->
<!--            <el-popover-->
<!--                    placement="bottom"-->
<!--                    width="90"-->
<!--                    trigger="hover">-->
<!--                <img width="90" :src="companyInfo.wechat">-->
<!--                <span slot="reference">-->
<!--                    <el-image :src="weixinIcon" fit="fill"></el-image>关注微信-->
<!--                </span>-->
<!--            </el-popover>-->

<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
    <div class="color-fff">
      <div class="header-tab w-1180">
        <el-image :src="headerLogo" fit="fill"></el-image>
        <div class="tab-content">
          <div class="header-menu">
            <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal">
              <el-menu-item v-for="(item, i) in menuList.filter(m => !m.hide)" :key="i" :index="item.activeIndex" @click="handleSelect(item)">
                  {{ item.title }}
              </el-menu-item>
            </el-menu>
          </div>
            <div v-if="userInfo.cstNm" class="header-login">
                <el-dropdown @command="handleCommand">
                    <span style="display: flex;align-items: center;" class="el-dropdown-link pointer">
                        <span class="cst-nm ellipsis1">{{userInfo.cstNm}}</span><i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item :command="{type: 'hash', hash: '/user/index'}" icon="el-icon-user">个人中心</el-dropdown-item>
                        <el-dropdown-item :command="{type: 'logout'}" icon="el-icon-circle-close">退出</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
          <!-- <div v-else class="header-login">
            <el-button class="registerBtn" @click="toHash('/register')" round>注册</el-button>
            <el-button class="loginBtn" @click="toHash('/login')" type="primary" round>登录</el-button>
          </div> -->
          <div class="big-login">
            <!-- <span class="speak-span" @click="handleSpeak">{{ !isSpeak ? '开启语音播报': '关闭语音播报' }}</span> -->
            <span class="big-span" @click="clickBig">{{!isBig ?'大字关怀版': '普通版'}}</span>
          </div>
        </div>
      </div>
    </div>
    <div
      class="top-image decorate"
      :title="menuList[activeIndex].val.title"
      :style="'background-image:url(' + menuList[activeIndex].val.url + ');height:' + hg + 'px'"
      @click="toUrl(menuList[activeIndex].val.link)"
      v-if="menuList[activeIndex].code"
    >
      <div class="center w-1180">
        <div class="title">{{ menuList[activeIndex].title }}</div>
        <div class="desc">为人民理财 服务国家建设</div>
      </div>
        <div v-if="menuList[activeIndex].code" id="edit-mask" style="display: none;">
            <span :editinfo="menuList[activeIndex].code" class="mask-edit-btn">编辑</span>
        </div>
    </div>
  </div>
</template>

<script>
import headerLogo from '@/assets/footerLogo.png';
import appIcon from '@/assets/appIcon.png';
import huiIcon from '@/assets/huiIcon.png';
import weixinIcon from '@/assets/weixinIcon.png';
import { logout } from "@/api/user";

export default {
  data() {
    return {
        companyInfo: {},
        userInfo: { cstNm: '' },
      headerLogo,
      appIcon,
      huiIcon,
      weixinIcon,
      activeIndex: '0',
      hg: 300,
      menuList: [
        {
          title: '首页',
          path: '/main',
            activeIndex: '0',
            code: ''
        },
        {
          title: '公募理财',
          path: '/product',
          code: 'product_top_banner|banner|1920x300|product',
          val: { link: '', title: '', url: '' },
            activeIndex: '1'
        },
        {
            title: '公募理财',
            path: '/product-detail',
            code: 'product_top_banner|banner|1920x300|product',
            val: { link: '', title: '', url: '' },
            hide: true,
            activeIndex: '2'
        },
          {
              title: '私募理财',
              path: '/pri-product',
              code: 'product_top_banner|banner|1920x300|product',
              val: { link: '', title: '', url: '' },
              hide: true,
              activeIndex: '3'
          },
        {
            title: '私募理财',
            path: '/pri-product-detail',
            code: 'product_top_banner|banner|1920x300|product',
            val: { link: '', title: '', url: '' },
            hide: true,
            activeIndex: '4'
        },
        {
          title: '投资陪伴',
          path: '/invest',
          code: 'invest_top_banner|banner|1920x300|invest',
          val: { link: '', title: '', url: '' },
            activeIndex: '5'
        },
        {
          title: '信息披露',
          path: '/info-dis',
          code: 'info_dis_top_banner|banner|1920x300|info-dis',
          val: { link: '', title: '', url: '' },
            activeIndex: '6'
        },
        {
          title: '关于我们',
          path: '/about',
          code: 'about_top_banner|banner|1920x300|about',
          val: { link: '', title: '', url: '' },
            activeIndex: '7'
        },
        {
            title: '个人中心',
            path: '/user/index',
            code: '',
            val: { link: '', title: '', url: '' },
            hide: true,
            activeIndex: '99'
        },
      ],
      isSpeak: false,
    };
  },
  props: {
    isBig: {
      type: Boolean,
      default: false
    }
  },
  //监听路由变化
  watch: {
      '$store.getters.commonInfo': {
          handler (newVal) {
              this.companyInfo = newVal.companyInfo
          }
      },
      '$store.getters.userInfo': {
          handler (newVal) {
              this.userInfo = newVal
          }
      },
      '$store.getters.decorateInfo': {
          handler (newVal) {
              this.menuList[1].val = newVal['product_top_banner']
              this.menuList[2].val = newVal['product_top_banner']
              this.menuList[3].val = newVal['product_top_banner']
              this.menuList[4].val = newVal['product_top_banner']
              this.menuList[5].val = newVal['invest_top_banner']
              this.menuList[6].val = newVal['info_dis_top_banner']
              this.menuList[7].val = newVal['about_top_banner']
          },
          immediate: true
      },
    $route: {
      handler(to) {
          let metaPath = ''
          if (to.matched[0] && to.matched[0].path) {
              metaPath = to.matched[0].path
          } else if (to.matched[1] && to.matched[1].path) {
              metaPath = to.matched[1].path
          }
        if (metaPath) {
            if (metaPath === '/product-detail') {
                this.activeIndex = '1'
            } else if (metaPath === '/pri-product-detail' || metaPath === '/pri-notice') {
                this.activeIndex = '3'
            } else {
                let flag = false
                this.menuList.filter(m => !m.hide).map((item) => {
                    if (item.path === metaPath) {
                        flag = true
                        this.activeIndex = item.activeIndex
                    }
                })
                if (!flag) {
                    this.activeIndex = '0'
                }
            }
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
      this.isSpeak = localStorage.getItem('voiceSwitch') === 'true' ? true : false
      this.companyInfo = this.$store.getters.commonInfo.companyInfo
      this.userInfo = this.$store.getters.userInfo
      this.menuList[1].val = this.$store.getters.decorateInfo.product_top_banner
      this.menuList[2].val = this.$store.getters.decorateInfo.product_top_banner
      this.menuList[3].val = this.$store.getters.decorateInfo.product_top_banner
      this.menuList[4].val = this.$store.getters.decorateInfo.product_top_banner
      this.menuList[5].val = this.$store.getters.decorateInfo.invest_top_banner
      this.menuList[6].val = this.$store.getters.decorateInfo.info_dis_top_banner
      this.menuList[7].val = this.$store.getters.decorateInfo.about_top_banner
      this.resizeFunc(this.resize,200)
      this.$root.$on('globalResize', this.resize)
  },
  methods: {
      beforeDestroy() {
          this.$root.$off('globalResize', this.resize);
      },
      handleCommand(cm) {
          switch (cm.type) {
              case 'hash':
                  this.toHash(cm.hash)
                  break
              case 'logout':
                  logout().then(() => {
                      location.reload()
                  })
                  break
          }
      },
      resize() {
          this.hg = this.$global.scale() * 300
      },
    handleSelect(value) {
      this.$router.push(value.path)
    },
    clickBig(){
      // this.isBig = !this.isBig;
      this.$emit('toggle-big')
      // document.documentElement.style.fontSize = `${(this.isBig ? 1.5 : 1) * 16}px`
      // document.documentElement.style.width = `${(this.isBig ? 1.5 : 1) * 100}%`
      // document.body.style.zoom = this.isBig ? 1.5 : 1
    },
    async handleSpeak(){
      if(!this.$isSupportSpeech()){
        this.$message.warning('浏览器不支持语音播报')
        return
      }
      if(localStorage.getItem('voiceSwitch') === 'true'){
        this.isSpeak = false
        await this.$closeVoiceSwitch()
        this.$message.success('语音播报已关闭')
        return;
      }
      try {
        this.isSpeak = true
        await this.$openVoiceSwitch()
        this.$message.success('语音播报已开启，可以使用点读功能')
        try {
          await this.$speakEnqueue('语音播报已开启，可以使用点读功能', {rate:0.9})
        }catch(e){
          console.error('播报失败',e)
        }
        
      } catch (err) {
        console.error(err)
        this.$message.error('开启失败：' + err.message)
      }
      
    },
  },
};
</script>

<style lang="scss" scoped>
.color-fff {
  background: #fff;
}
.jxlc-header {
  //width: 100%;

  .flex-center {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .header-top {
    padding: 10px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    //width: 1180px;
    margin: auto;
    .header-left {
      font-size: 14px;
      line-height: 19.6px;
      text-align: left;
      a{
        color: #333333;
      }
    }
    .header-right {
      display: flex;
      align-items: center;
      font-size: 13px;
      line-height: 18.2px;
      color: #333333;
      :deep(.el-popover__reference){
        display: flex;
        height: 24px;
        line-height: 24px;
        cursor: pointer;
      }
      .el-image {
        width: 24px;
        height: 24px;
        padding-right: 4px;
      }
      .header-lines {
        margin: 0 16px;
        width: 1px;
        height: 16px;
        background: #dddddd;
      }
    }
  }
  .header-tab {
    padding: 20px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    //width: 1180px;
    margin: auto;
    .el-image {
      width: 200px;
      height: 50px;
    }
    .el-menu-item {
      margin-right: 40px !important;
      padding: 0;
    }

    .tab-content {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .header-menu {
        .el-menu {
          border-bottom: none;
        }
        .el-menu-item {
          font-size: 18px;
          color: #333333;
        }
        .is-active {
          font-weight: 600;
          color: #005bac;
        }
      }
      .header-login {
        .cst-nm{
          max-width: 112px;
          overflow: hidden;
          text-align: right;
        }
        .registerBtn {
          line-height: 19.6px;
          color: #005bac;
          padding: 6px 22px;
          border: 1px solid #005bac;
        }
        .loginBtn {
          line-height: 19.6px;
          padding: 6px 22px;
          background: #005bac;
        }
      }
      .big-login{
        position: absolute;
        right: 20px;
        top: 10px;
        span{
          cursor: pointer;
        }
      }
    }
  }
  .top-image {
    cursor: pointer;
    //padding: 100px 0;
    min-height: 100px;
    background-repeat: 'no-repeat';
    background-size: cover;
    color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    .title {
      font-size: 40px;
      font-weight: 600;
      line-height: 56px;
      padding-bottom: 16px;
    }
    .desc {
      font-size: 20px;
      line-height: 28px;
    }
  }
}
.speak-span{
  margin-right: 20px;
}
</style>
